import type { QueryClient } from '@tanstack/react-query';

import { libraryKeys } from '@/shared/features/quiz-library/api/library.keys';
import { invalidateMyQuizList } from '@/shared/features/quiz-list/utils/myQuizListCache';

import { folderKeys } from './folder.keys';
import { refetchFolderListsAfterIndexLag } from './folderListCache';

/**
 * 폴더가 바뀐 뒤 낡는 조회를 한 번에 무효화한다.
 *
 * - 폴더 목록: 이름·개수·공개 범위가 카드에 보인다. 검색 인덱스를 읽어 바로 받은 값이 낡을 수 있어
 *   인덱스가 따라온 뒤 한 번 더 받는다(`invalidateMyQuizList` 와 같은 규칙).
 * - 자료실 혼합 목록: 공개 폴더가 실려 있어 staleTime 동안 남는다.
 * - 내 퀴즈: 카드의 폴더 표시와 rootOnly 결과가 소속을 따른다.
 * - 상세(`folderId` 를 줄 때만): 삭제된 폴더는 무효화 대신 `removeQueries` 로 지운다.
 */
export const invalidateFolderRelated = (
  queryClient: QueryClient,
  folderId?: string,
) => {
  if (folderId) {
    void queryClient.invalidateQueries({
      queryKey: folderKeys.detail(folderId),
    });
  }
  void queryClient.invalidateQueries({ queryKey: folderKeys.lists() });
  refetchFolderListsAfterIndexLag(queryClient);
  void queryClient.invalidateQueries({ queryKey: libraryKeys.all });
  invalidateMyQuizList(queryClient);
};
